import React, { Component } from "react";
import produce from "immer";
import { DesignContextProvider } from "./context";

let DProvider;

if (process.env.DESIGNER === "yes") {
  class DesignProvider extends Component {
    key = 0;

    setDesignProps = k => props => {
      this.setState(
        produce(state => {
          state.designers[k].props = props;
        })
      );
    };

    getDesignProps = k => () => {
      return this.state.designers[k].props;
    };

    registerDesigner = (designer, props) => {
      const nextKey = this.key++;
      const getDesignProps = this.getDesignProps(nextKey);
      const setDesignProps = this.setDesignProps(nextKey);

      this.setState(
        produce(state => {
          state.designers[nextKey] = {
            Component: designer,
            props,
            setDesignProps,
            getDesignProps
          };
        })
      );

      return [
        getDesignProps,
        setDesignProps,
        () => {
          this.setState(
            produce(state => {
              delete state.designers[nextKey];
            })
          );
        }
      ];
    };

    constructor(props) {
      super(props);

      this.state = {
        designers: {},
        registerDesigner: this.registerDesigner
      };
    }

    render = () => (
      <DesignContextProvider value={this.state}>
        {this.props.children || null}
      </DesignContextProvider>
    );
  }

  DProvider = DesignProvider;
} else {
  DProvider = ({ children }) => children;
}

export default DProvider;
